import { render, staticRenderFns } from "./LandsideApp.vue?vue&type=template&id=6bdb897e&"
import script from "./LandsideApp.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideApp.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LandsideApp.vue?vue&type=style&index=0&id=6bdb897e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports